<p-confirmDialog [baseZIndex]="20000"></p-confirmDialog>

<div class="wrapper">
  <p-table
    [value]="categories"
    [rows]="8"
    [paginator]="true"
    [loading]="loading"
    [responsiveLayout]="'scroll'"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th style="width: 110px">Art</th>
        <th style="width: 90px">Aktion</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-c>
      <tr>
        <td>{{ c.name }}</td>
        <td>{{ kindLabel(c.kind) }}</td>
        <td>
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            class="p-button-text p-button-danger p-button-sm"
            (click)="remove(c)"
            [disabled]="loading"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="divider"></div>

  <form [formGroup]="form" class="add-row" (ngSubmit)="add()">
    <div class="field">
      <label class="static-label">Neue Kategorie</label>
      <input pInputText formControlName="name" placeholder="z.B. Notebook" />
      @if (form.get('name')?.touched && form.get('name')?.invalid) {
        <small class="p-error">Name ist erforderlich.</small>
      }
    </div>

    <button
      pButton
      type="submit"
      icon="pi pi-plus"
      label="Hinzufügen"
      class="p-button-success"
      [loading]="loading"
      [disabled]="loading"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-times"
      label="Schließen"
      class="p-button-secondary"
      (click)="close()"
      [disabled]="loading"
    ></button>
  </form>
</div>
